import {
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import {
  EnvironmentProviders,
  makeEnvironmentProviders
} from '@angular/core';
import {
  MsalBroadcastService,
  MsalInterceptor,
  MsalService,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG
} from '@azure/msal-angular';
import {
  msalInstanceFactory,
  msalInterceptorConfigFactory
} from './msal.config';

// IMPORTANT: do NOT short-circuit based on `isMsalConfigured()` here.
// `provideMsal()` is invoked while the `appConfig` module is being imported,
// which happens BEFORE `loadRuntimeConfig()` mutates `environment` with the
// values from `/api/config`. Reading the environment at this point sees only
// the empty placeholders from `environment.{dev,uat,prod}.ts`, which would
// cause MsalService to never be registered even when valid App Settings exist
// in Azure. The factories below already read the environment lazily (Angular
// only calls them when MsalService is first injected, which happens after
// bootstrap), so by then the runtime config has been applied.
export function provideMsal(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: MSAL_INSTANCE,
      useFactory: msalInstanceFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: msalInterceptorConfigFactory
    },
    MsalService,
    MsalBroadcastService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    }
  ]);
}
